import { Foreground, Background, Stroke, BorderSize } from '@front/sharedcomponents/Styles';
export var IconButtonType;
(function (IconButtonType) {
    IconButtonType["PanelTool"] = "panel_tool";
    IconButtonType["Action"] = "action_button";
})(IconButtonType || (IconButtonType = {}));
export const IconButtonTypeClass = {
    [IconButtonType.PanelTool]: `${Background.Secondary} ${Foreground.Secondary} ${Stroke.General} ${BorderSize.Solid1}`,
    [IconButtonType.Action]: `${Background.Secondary} ${Foreground.Secondary} ${BorderSize.None}`
};
export const SelectedIconButtonTypeClass = {
    [IconButtonType.PanelTool]: `${Background.Primary} ${Foreground.Primary} ${Stroke.General} ${BorderSize.Solid1}`,
    [IconButtonType.Action]: `${Background.Primary} ${Foreground.Primary} ${BorderSize.None}`
};
